// Copyright (c) 2015, Lucrumerp Pvt. Ltd. and Contributors
// MIT License. See license.txt

import FileUploader from "./file_uploader";

ducky.provide("ducky.ui");
ducky.ui.FileUploader = FileUploader;
